module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp2_6000.cc8e3b8f.png";